// extracted by mini-css-extract-plugin
export default {"select":"Select_select__vG+1H","select__icon":"Select_select__icon__-gLjX"};